"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauQuerygatewayV1TableInfoIconEnumEnum;
(function (TableauQuerygatewayV1TableInfoIconEnumEnum) {
    TableauQuerygatewayV1TableInfoIconEnumEnum["ListItem"] = "LIST_ITEM";
    TableauQuerygatewayV1TableInfoIconEnumEnum["Sheet"] = "SHEET";
    TableauQuerygatewayV1TableInfoIconEnumEnum["FoundTable"] = "FOUND_TABLE";
    TableauQuerygatewayV1TableInfoIconEnumEnum["NamedRange"] = "NAMED_RANGE";
    TableauQuerygatewayV1TableInfoIconEnumEnum["StoredProcedure"] = "STORED_PROCEDURE";
})(TableauQuerygatewayV1TableInfoIconEnumEnum = exports.TableauQuerygatewayV1TableInfoIconEnumEnum || (exports.TableauQuerygatewayV1TableInfoIconEnumEnum = {}));
function TableauQuerygatewayV1TableInfoFromJSON(json) {
    return TableauQuerygatewayV1TableInfoFromJSONTyped(json, false);
}
exports.TableauQuerygatewayV1TableInfoFromJSON = TableauQuerygatewayV1TableInfoFromJSON;
function TableauQuerygatewayV1TableInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'caption': !runtime_1.exists(json, 'caption') ? undefined : json['caption'],
        'tooltip': !runtime_1.exists(json, 'tooltip') ? undefined : json['tooltip'],
        'sortKey': !runtime_1.exists(json, 'sort_key') ? undefined : json['sort_key'],
        'iconEnum': !runtime_1.exists(json, 'icon_enum') ? undefined : json['icon_enum'],
        'isEnabled': !runtime_1.exists(json, 'is_enabled') ? undefined : json['is_enabled'],
        'ranking': !runtime_1.exists(json, 'ranking') ? undefined : json['ranking'],
        'userAgnostic': !runtime_1.exists(json, 'user_agnostic') ? undefined : json['user_agnostic'],
    };
}
exports.TableauQuerygatewayV1TableInfoFromJSONTyped = TableauQuerygatewayV1TableInfoFromJSONTyped;
function TableauQuerygatewayV1TableInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'caption': value.caption,
        'tooltip': value.tooltip,
        'sort_key': value.sortKey,
        'icon_enum': value.iconEnum,
        'is_enabled': value.isEnabled,
        'ranking': value.ranking,
        'user_agnostic': value.userAgnostic,
    };
}
exports.TableauQuerygatewayV1TableInfoToJSON = TableauQuerygatewayV1TableInfoToJSON;
